import React from 'react';
import styled from 'styled-components';

import SectionWrapper from '../../products/events/SectionWrapper';
import RegistrationAndTicketing from '../../products/events/RegistrationAndTicketing';
import ProductIntroduce from '../../../components/products/events/ProductIntroduce';

import personIcon from '../../../images/products/membership/person_icon.svg';

import membershipmanagementImg from '../../../images/products/membership/membershipmanagement.png';
import membershipmanagementImg2x from '../../../images/products/membership/membershipmanagement@2x.png';
import membershipmanagementImg3x from '../../../images/products/membership/membershipmanagement@3x.png';

import ApprovedRejectedImg from '../../../images/products/membership/approved_rejected.png';
import ApprovedRejectedImg2x from '../../../images/products/membership/approved_rejected@2x.png';
import ApprovedRejectedImg3x from '../../../images/products/membership/approved_rejected@3x.png';

import JuvenPlansImg from '../../../images/products/membership/juvenplans.png';
import JuvenPlansImg2x from '../../../images/products/membership/juvenplans@2x.png';
import JuvenPlansImg3x from '../../../images/products/membership/juvenplans@3x.png';

import MembersOnlyTicketsImg from '../../../images/products/membership/membersonlytickets.png';
import MembersOnlyTicketsImg2x from '../../../images/products/membership/membersonlytickets@2x.png';
import MembersOnlyTicketsImg3x from '../../../images/products/membership/membersonlytickets@3x.png';

import SignupAndRenewalImg from '../../../images/products/membership/signupandrenewal.png';
import SignupAndRenewalImg2x from '../../../images/products/membership/signupandrenewal@2x.png';
import SignupAndRenewalImg3x from '../../../images/products/membership/signupandrenewal@3x.png';

import { translate } from '../../../../i18n';

const t = translate(
  'components/products/membership/simplifyMembershipManagement'
);

const SectionHeading = styled.h2`
  text-align: center;
  font-size: 25px;
  line-height: 1.2;
  font-weight: bold;
  margin: 0 auto;
  width: 100%;
  padding-bottom: 88px;
  text-transform: none;

  @media (max-width: 900px) {
    width: 80%;
    padding-bottom: 0px;
    font-size: 20px;
  }
`;

export default () => (
  <SectionWrapper
    backgroundColor
    paddingTop='73'
    paddingBottomMob='90'
    customPaddingBottom='120'
  >
    <ProductIntroduce
      title={ t('Simplify membership management') }
      fontSizeWeb='20'
      fontSizeMob='20'
      imgSrc={ personIcon }
    />
    <RegistrationAndTicketing
      noExtraMarginTop
      description={ t(
        'Create membership plans, tag and segment your members, communicate with emails and forms, and integrate with events and discounts. Collaborate tasks and align with everyone in one membership system.'
      ) }
      ImgSpacingOnRight='5%'
      descriptionLineHeight='1.6'
      marginTop='120'
      marginLeft='20px'
      descriptionInMid
      marginTopMob='30'
      contentMarginTop='10'
      headingMarginBottom='10'
      descriptionFontSize='12'
      imgSrc={ membershipmanagementImg }
      srcSet={ `${ membershipmanagementImg3x } 3x, ${ membershipmanagementImg2x } 2x, ${ membershipmanagementImg } 1x` }
      title={ t('The all-in-one membership platform') }
    />
    <RegistrationAndTicketing
      description={ t(
        'Manage membership your way. Review and approve every application to be exclusive, or list your membership on the Juven platform and invite everyone to join.'
      ) }
      descriptionLineHeight='1.6'
      alignLeft
      imgOnLeft
      descriptionInMid
      marginTop='120'
      marginTopMob='90'
      noExtraMarginTop
      contentMarginTop='10'
      headingMarginBottom='10'
      descriptionFontSize='12'
      imgSrc={ ApprovedRejectedImg }
      srcSet={ `${ ApprovedRejectedImg3x } 3x, ${ ApprovedRejectedImg2x } 2x, ${ ApprovedRejectedImg } 1x` }
      title={ t('Exclusive, or open to everyone') }
    />
    <RegistrationAndTicketing
      description={ t(
        'Manage and own your unique membership system. Set criteria for your different membership plans.'
      ) }
      ImgSpacingOnRight='5%'
      descriptionLineHeight='1.6'
      marginLeft='20px'
      descriptionInMid
      marginTop='120'
      marginTopMob='90'
      noExtraMarginTop
      contentMarginTop='10'
      headingMarginBottom='10'
      descriptionFontSize='12'
      imgSrc={ JuvenPlansImg }
      srcSet={ `${ JuvenPlansImg3x } 3x, ${ JuvenPlansImg2x } 2x, ${ JuvenPlansImg } 1x` }
      title={ t('Ensure your members join the right plan') }
    />
    <RegistrationAndTicketing
      description={ t(
        'Keep your members happy with exclusive ticket options for any event, as well as deals and benefits.'
      ) }
      descriptionLineHeight='1.6'
      alignLeft
      imgOnLeft
      descriptionInMid
      marginTop='120'
      marginTopMob='90'
      noExtraMarginTop
      contentMarginTop='10'
      headingMarginBottom='10'
      descriptionFontSize='12'
      imgSrc={ MembersOnlyTicketsImg }
      srcSet={ `${ MembersOnlyTicketsImg3x } 3x, ${ MembersOnlyTicketsImg2x } 2x, ${ MembersOnlyTicketsImg } 1x` }
      title={ t('Members-only tickets and discounts') }
    />
    <RegistrationAndTicketing
      description={ t(
        'Juven\'s membership system includes fully customizable application form that can be accessed easily from any device.'
      ) }
      descriptionLineHeight='1.6'
      descriptionInMid
      contentLeftPadding='133'
      contentMarginTop='10'
      headingMarginBottom='10'
      descriptionFontSize='12'
      imgSrc={ SignupAndRenewalImg }
      srcSet={ `${ SignupAndRenewalImg3x } 3x, ${ SignupAndRenewalImg2x } 2x, ${ SignupAndRenewalImg } 1x` }
      title={ t('Intuitive signup and renewal') }
    />
  </SectionWrapper>
);



// WEBPACK FOOTER //
// ./src/components/products/membership/simplifyMembershipManagement.js